<template>
  <TresGroup
    :position="[(-itemsPerRow * hSpace) / 2, ((items.length / itemsPerRow) * vSpace) / 4, -50]"
  >
    <Suspense>
      <CanvasClientsItem
        v-for="(item, idx) in items"
        :key="idx"
        :position="[
          item.row % 2 === 0 ? item.position * hSpace : (item.position + 0.5) * hSpace,
          item.row * -vSpace,
          0
        ]"
        :title="item.title"
        :scene="scene"
        :logo="item.logo"
        :url="item.url"
      />
    </Suspense>
  </TresGroup>
</template>
<script setup lang="ts">
import { useGLTF } from '@tresjs/cientos'
const path = '/models/box_clients.glb'
const { scene } = await useGLTF(path, { draco: true })

const props = defineProps<{
  data: ClientRecord[] | []
}>()

const vSpace = ref(4)
const hSpace = ref(8)
const itemsPerRow = ref(15)

// Array from DatoCMS with title, URL and logo
const items = []

while (items.length < 300) {
  for (const client of props.data) {
    if (client.textureLight === null) continue
    items.push({
      row: 0,
      position: 0,
      title: client.title,
      url: client.url,
      logo: client.textureLight.responsiveImage.src
    })
    if (items.length >= 300) break
  }
}

let rowNum = -1
for (let i = 0; i < items.length; i++) {
  if ((i + 1) % itemsPerRow.value == 0) {
    rowNum++
  }
  items[i].row = rowNum
  items[i].position = i % itemsPerRow.value
}
</script>
